import { render, staticRenderFns } from "./ObjectsDetail.vue?vue&type=template&id=f1d0b0d2"
import script from "./ObjectsDetail.vue?vue&type=script&lang=js"
export * from "./ObjectsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports